module.exports = __webpack_public_path__ + "img/step01_a_stand_power_remove_film_cut_straps.d239409a.png";